import { isFunction } from "src/app/helpers/type-utils";

export class NavbarItem {

	public id: number | undefined;
	public name: string;
	public isActive:boolean;
	public _pathProvider: (() => string) | undefined;

	private _path: string | undefined;
	public get path(): string | undefined {
		if (!this._path && this._pathProvider) {
			this._path = this._pathProvider();
			
			return this._path;
		}

		return this._path;
	}
	public set path(value: string | undefined) {
		this._path = value;
	}

	public parentId: number | null | undefined;
	public icon: string;
	public sortingPriority: number;
	public routeId: number | undefined;

	public expanded: boolean | undefined;

	public children: NavbarItem[] | undefined;
	public isRelativelyLast: boolean | undefined;

	public onClick: () => void;

	constructor(
		parameters?: {
			id?: number | undefined,
			name?: string,
			path?: string | (() => string) | undefined,
			parentId?: number | null | undefined,
			icon?: string,
			sortingPriority?: number,
			routeId?: number | undefined,

			expanded?: boolean | undefined,

			children?: NavbarItem[] | undefined,
			isRelativelyLast?: boolean | undefined,

			onClick?: () => void,
		}
	) {
		this.id = parameters?.id;
		this.name = parameters?.name ?? "";
		this._pathProvider = isFunction(parameters?.path) ? parameters?.path : () => parameters?.path as string;
		this.parentId = parameters?.parentId;
		this.icon = parameters?.icon ?? "";
		this.sortingPriority = parameters?.sortingPriority ?? 0;
		this.expanded = parameters?.expanded;
		this.children = parameters?.children;
		this.isRelativelyLast = parameters?.isRelativelyLast;
		this.routeId = parameters?.routeId;
		this.onClick = parameters?.onClick ?? (() => {});
	}
}
